import { JsonFormProperty } from '@evidentid/json-schema/interfaces/JsonForm';
import JsonSchema, { JsonSchemaObject } from '@evidentid/json-schema/interfaces/JsonSchema';
import { isObject } from '@evidentid/json-schema/schemaChecks';

import { EntityStandardPropertyName } from '@/modules/entity-management/models/EntityStandardPropertyName.model';

function getObjectPropertyLabel(schema: JsonSchema, key: string): string {
    if (!isObject(schema)) {
        return '';
    }
    return (schema as JsonSchemaObject).properties[key]?.title || key;
}

function getObjectPropertyLabels(schema: JsonSchema): string[] {
    const props = Object.values((schema as JsonSchemaObject).properties);
    return props.map((prop) => `${prop.title}`);
}

function getObjectPropNames(schema: JsonSchema): string[] {
    return ('propertiesOrder' in schema &&
        schema.propertiesOrder &&
        schema.propertiesOrder.length > 0)
        ? schema.propertiesOrder
            .map((key) => getObjectPropertyLabel(schema, key))
        : getObjectPropertyLabels(schema);
}

export function getFlattenedStandardPropertyNames(properties: JsonFormProperty[]): string[] {
    const names = [] as string[];
    properties.forEach((property) => {
        if (property.name === EntityStandardPropertyName.address) {
            // TODO[PRODUCT-23623]: band-aid for address conflict, needs support generic object type standard prop
            const addressNames = getObjectPropNames(property.form.schema);
            names.push(...addressNames.map((x) => `Entity Address ${x}`));
        } else {
            names.push(property.form.schema.title || property.name);
        }
    });
    return names;
}
